import { Navigate } from "react-router-dom";
import { useUserRoles } from "@/hooks/useUserRoles";
import { Loader2 } from "lucide-react";

interface ProtectedJobSeekerRouteProps {
  children: React.ReactNode;
}

const ProtectedJobSeekerRoute = ({ children }: ProtectedJobSeekerRouteProps) => {
  const { data: roles, isLoading } = useUserRoles();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const isJobSeeker = roles?.includes("job_seeker");

  if (!isJobSeeker) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedJobSeekerRoute;
